import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "tachyons"
import App from './Containers/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
